import Drawer from "../../../../drawer/Drawer";
import ReportDetails from "../ReportDetails";

const ReportDetailsDrawer = ({ open, close = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl3"}
      size={"xl3"}
      title={<span className="tracking-tighter uppercase">Report Details</span>}
      subtitle="View report details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
    >
      <ReportDetails data={data} />
    </Drawer>
  );
};

export default ReportDetailsDrawer;
